module.exports = __webpack_public_path__ + "static/media/ouzeria_thumb.756c0daf.webp";